import { createSlice } from "@reduxjs/toolkit"
import { getUserDesignation } from "./filterSectionAction";
import { getReligion } from "./filterSectionAction";
import { getUserMarriageState } from "./filterSectionAction";
import { getUserCaste } from "./filterSectionAction";
import { getUserCountry } from "./filterSectionAction";
import { getUserDistrict } from "./filterSectionAction";

const initialState = {
  loading: false,
  success: false,
  designationData: [],
  religionListData: [],
  casteListData: [],
  marriageListData: [],
  countryListData: [],
  districtListData: [],
  error: ''
}

const filterSection = createSlice({
  name: 'filter',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserDesignation.pending, (state) => {
        state.loading = true;
        state.success = false;
      })
      .addCase(getUserDesignation.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.designationData = action.payload;
      })
      .addCase(getUserDesignation.rejected, (state, action) => {
        state.success = false;
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getReligion.pending, (state) => {
        state.loading = true;
        state.success = false;
      })
      .addCase(getReligion.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.religionListData = action.payload;
      })
      .addCase(getReligion.rejected, (state, action) => {
        state.success = false;
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getUserMarriageState.pending, (state) => {
        state.loading = true;
        state.success = false;
      })
      .addCase(getUserMarriageState.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.marriageListData = action.payload;
      })
      .addCase(getUserMarriageState.rejected, (state, action) => {
        state.success = false;
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getUserCaste.pending, (state) => {
        state.loading = true;
        state.success = false;
      })
      .addCase(getUserCaste.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.casteListData = action.payload;
      })
      .addCase(getUserCaste.rejected, (state, action) => {
        state.success = false;
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getUserCountry.pending, (state) => {
        state.loading = true;
        state.success = false;
      })
      .addCase(getUserCountry.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.countryListData = action.payload;
      })
      .addCase(getUserCountry.rejected, (state, action) => {
        state.success = false;
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getUserDistrict.pending, (state) => {
        state.loading = true;
        state.success = false;
      })
      .addCase(getUserDistrict.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.districtListData = action.payload;
      })
      .addCase(getUserDistrict.rejected, (state, action) => {
        state.success = false;
        state.loading = false;
        state.error = action.payload;
      })
  }
})

export default filterSection.reducer
